import React from "react"

import Layout from "../components/layout"
import PageHeader from "../components/pageHeader"
import SocialMediaIcons from "../components/socialMediaIcons"

export default function Contact() {
  return (
    <Layout>
      <PageHeader>Contact</PageHeader>
      <p>
        Email: <br/>
        n.ulricksen ( at ) gmail ( dot ) com
      </p>
      <br/>
      <p>Social Media:</p>
      <SocialMediaIcons />
    </Layout>
  )
}
